// extracted by mini-css-extract-plugin
export default {"CopyrightFooter":"CopyRightFooter_CopyrightFooter__Qa2tg"};